import { ContentSection } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { useAccountingCategoryOptions } from '../../queries/useAccountingCategoryOptions';
import { useIsAccountingCategorySetupRequired } from '../../queries/useIsAccountingCategorySetupRequired';

export const AccountingStepFields = ({ isDefaultProduct }: { isDefaultProduct?: boolean }) => {
    const accountingCategoryOptions = useAccountingCategoryOptions();
    const isAccountingCategorySetupRequired = useIsAccountingCategorySetupRequired();

    return (
        <ContentSection
            title={lt('AccountingCategoryPlural')}
            description={lt('ProductFormAccountingCategorySectionDescription')}
            spacing="300"
            contentSpacing="200"
        >
            <SelectField
                autoFocus
                disabled={isDefaultProduct}
                name="accountingCategoryId"
                label={lt('ProductAccountingCategoryCharged')}
                options={accountingCategoryOptions}
                required={isAccountingCategorySetupRequired}
                emptyValueAsNull
            />
            <SelectField
                disabled={isDefaultProduct}
                name="rebateAccountingCategoryId"
                label={lt('ProductAccountingCategoryRebated')}
                options={accountingCategoryOptions}
                emptyValueAsNull
            />
            <SelectField
                disabled={isDefaultProduct}
                name="canceledItemAccountingCategoryId"
                label={lt('ProductAccountingCategoryCanceled')}
                options={accountingCategoryOptions}
                emptyValueAsNull
            />
        </ContentSection>
    );
};
